module.exports = __webpack_public_path__ + "img/idea.717a27e4.svg";